<div class="features">
  <h3 class="text-xxl text-center text-bold text-black" i18n="@@front.home.getStarted.title">Get started in minutes</h3>
  <p class="text-gray text-center" i18n="@@front.home.getStarted.description">BitOasis is the largest and most trusted crypto platform in the region</p>
  <div class="p-3"></div>
  <div class="container">
    <div class="row align-items-top">
      <div class="col-lg feature">
        <div class="img">
          <img src="assets/images/home/get-started/{{theme$ | async}}/create.svg" alt="">
        </div>
        <h3 class="title"  i18n="@@front.home.getStarted.item1.title">1. Register</h3>
        <p class="text" i18n="@@front.home.getStarted.item1.description">Sign up to create your own free BitOasis account</p>
      </div>
      <!-- .feature -->
      <div class="col-lg feature">
        <div class="img">
          <img src="assets/images/home/get-started/{{theme$ | async}}/verify.svg" alt="">
        </div>
        <h3 class="title" i18n="@@front.home.getStarted.item2.title">2. Verify</h3>
        <p class="text" i18n="@@front.home.getStarted.item2.description">Verify your own identity with one of our trusted partners</p>
      </div>
      <!-- .feature -->
      <div class="col-lg feature">
        <div class="img">
          <img src="assets/images/home/get-started/{{theme$ | async}}/deposit.svg" alt="">
        </div>
        <h3 class="title" i18n="@@front.home.getStarted.item3.title">3. Deposit</h3>
        <p class="text" i18n="@@front.home.getStarted.item3.description">Deposit your funds securely through our supported options</p>
      </div>
      <!-- .feature -->
      <div class="col-lg feature">
        <div class="img">
          <img src="assets/images/home/get-started/{{theme$ | async}}/trade.svg" alt="">
        </div>
        <h3 class="title" i18n="@@front.home.getStarted.item4.title">4. Buy</h3>
        <p class="text" i18n="@@front.home.getStarted.item4.description">Buy and sell more than {{ (currencies$ | async)?.length || 80 }}+ crypto assets anytime, anywhere</p>
      </div>
      <!-- .feature -->
    </div>
  </div>
</div>
